var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column h-100",attrs:{"id":"app"}},[_c('nav-bar'),_c('div',{staticClass:"flex-grow-1 flow-container"},[_c('error'),_c('div',{},[_c('router-view')],1)],1),_c('loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }